import permissions from '@/util/ACL/permissionMap';

/**
 * The process and its activities for the shared Risk management tab (US 9369 + 9371), the process first.
 *
 * @param vm the page (for isGranted and the client)
 * @param process the process
 * @param row the row under the hero (processes/{process}/switcher or activities/{activity}/switcher)
 * @param activity the activity whose page it is, if any: its own permissions are checked on the full object
 */
export function processRiskSources(vm, process, row, activity) {
  let client = vm.$store.state.client;
  let editable = object => !client.parent || !!object.partition;
  // Without the full object only the workspace permission counts (a single name, as permissionCheck takes it)
  let allowed = (base, object) => object ? vm.isGranted([permissions[base], permissions[base + '_OWN']], object) : vm.isGranted(permissions[base]);

  let sources = [{
    key: 'process',
    kind: 'process',
    asset: 'processes',
    object: process,
    catalogueType: 'process',
    label: process.name,
    canCreate: allowed('PROCESS_RISK_SCENARIO_CREATE', process) && editable(process),
    canEdit: allowed('PROCESS_RISK_SCENARIO_EDIT', process) && editable(process),
    canDelete: allowed('PROCESS_RISK_SCENARIO_DELETE', process) && editable(process)
  }];

  (row ? row.children : []).filter(child => !child.shared).forEach(function(child) {
    let own = activity && activity.id === child.id ? activity : null;
    // Other activities: the workspace permission, as their own-ness isn't loaded here; the API checks again
    let object = own || { id: child.id, slug: child.slug, name: child.name, partition: process.partition };
    sources.push({
      key: 'activity-' + child.id,
      kind: 'activity',
      asset: 'activities',
      object: object,
      catalogueType: 'activity',
      label: child.name,
      canCreate: allowed('ACTIVITY_RISK_SCENARIO_CREATE', own) && editable(object),
      canEdit: allowed('ACTIVITY_RISK_SCENARIO_EDIT', own) && editable(object),
      canDelete: allowed('ACTIVITY_RISK_SCENARIO_DELETE', own) && editable(object)
    });
  });

  return sources;
}
